import {
  LOGIN_INIT,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  TWO_FACTOR_AUTH_INIT,
  TWO_FACTOR_AUTH_SUCCESS,
  TWO_FACTOR_AUTH_FAILED,
  VERIFY_PHONE_INIT,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_FAILED,
  SEND_TWO_FA_CODE_INIT,
  SEND_TWO_FA_CODE_SUCCESS,
  SEND_TWO_FA_CODE_FAILED,
  SEND_TFA_CODE_TO_EMAIL_INIT,
  SEND_TFA_CODE_TO_EMAIL_SUCCESS,
  SEND_TFA_CODE_TO_EMAIL_FAILED,
} from "./constants";
const initialState = {
  loading: false,
  loadingPhone: false,
  loadingEmail: false,
  token: "",
  isTFVRequired: false,
  isPhoneVerified: true,
  userId: null,
  phoneNumber: null,
  emailAddress: null,
  loginFailed: false,
};

export default function login(state = initialState, action) {
  switch (action.type) {
    case LOGIN_INIT:
      return { ...state, loading: true };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isTFVRequired: action.isTwoFactorEnable,
        token: action.token,
        isPhoneVerified: action.isPhoneVerified,
        userId: action.userId,
        phoneNumber: action.PhoneNumber,
        emailAddress: action.Email,
      };
    case LOGIN_FAILED:
      let failed = state.loginFailed;
      if (action.res === "Your Account Status is not Active") {
        failed = true;
      }
      return { ...state, loading: false, loginFailed: failed };
    case TWO_FACTOR_AUTH_INIT:
      return { ...state, loading: true };
    case TWO_FACTOR_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case TWO_FACTOR_AUTH_FAILED:
      return { ...state, loading: false };
    case VERIFY_PHONE_INIT:
      return { ...state, loading: true };
    case VERIFY_PHONE_SUCCESS:
      return {
        ...state,
        loading: false,
        verifyPhoneAuth: action.payload,
      };
    case VERIFY_PHONE_FAILED:
      return { ...state, loading: false };
    case SEND_TWO_FA_CODE_INIT:
      return { ...state, loadingPhone: true };
    case SEND_TWO_FA_CODE_SUCCESS:
      return {
        ...state,
        loadingPhone: false,
      };
    case SEND_TWO_FA_CODE_FAILED:
      return { ...state, loadingPhone: false };
    case SEND_TFA_CODE_TO_EMAIL_INIT:
      return { ...state, loadingEmail: true };
    case SEND_TFA_CODE_TO_EMAIL_SUCCESS:
      return {
        ...state,
        loadingEmail: false,
      };
    case SEND_TFA_CODE_TO_EMAIL_FAILED:
      return { ...state, loadingEmail: false };
    default:
      return state;
  }
}
